import { getQueryParams } from '@/helpers/utils'
import { externalRequest } from '@/helpers/api'
import { generateUserKey, setCookie, getDeviceInfo } from '@/helperMethods'
import { setUserKey } from '@/store/database'
import { getMyUser } from '@/store/memberships'
import { onboardingSteps } from '@/helpers/constants'
import { orgFlag, USER_PRONOUNS, USER_TITLE } from '@/helpers/flags'

export const prepareAppConfig = async () => {
	Object.assign(window.appConfig, {
		embedded: false,
		wrapper: false,
		authonly: false,
	})

	const params = getQueryParams()

	if (params.api_token) {
		try {
			const payload = {}
			payload.headers = {
				Authorization: `Bearer ${params.api_token}`,
			}
			const { data } = await externalRequest(
				'POST',
				'/api/v1/user.info',
				null,
				null,
				payload
			)
			if (data.ok) {
				if (params.device_uuid) {
					const uuid = params.device_uuid
					window.appConfig.device_uuid = uuid

					const devices = data.user.devices
					for (let device of devices) {
						if (device.uuid === uuid) {
							window.appConfig.device_type = device.type
							break
						}
					}
				}

				delete data.user.devices
				delete data.user.phones

				window.appConfig.api_token = params.api_token
				window.appConfig.user = data.user

				// Get encryption key.
				window.appConfig.userKey = generateUserKey()
				setUserKey(window.appConfig.userKey)
				setCookie('api_token', params.api_token)
			}
		} catch (err) {
			console.error('Error fetching user info:', err)
		}
	}

	if (!window.appConfig.device_type) {
		window.appConfig.device_type = getDeviceInfo().type
	}

	if (params.session_key) {
		window.appConfig.userKey = params.session_key
	}

	if (params.embedded) {
		window.appConfig.embedded = true
	}

	if (params.wrapper) {
		window.appConfig.wrapper = true
	}

	if (params.authonly) {
		window.appConfig.authonly = true
	}

	if (params.from) {
		window.appConfig.integration_name = params.from
	}

	if (params.push_token) {
		window.appConfig.push_token = params.push_token
	}

	if (params.suppress_errors === 'true') {
		window.appConfig.suppress_errors = true
	}
}

export const getRequiredOnboardingSteps = () => {
	const steps = []
	const user = getMyUser()
	user.client_meta = user.client_meta || {}
	// Uncomment to debug onboarding modal
	// steps.push(onboardingSteps.PROFILE_PIC)
	// steps.push(onboardingSteps.PRONOUNS)
	// steps.push(onboardingSteps.TITLE)

	if (
		!user.profilepic &&
		!user.client_meta.onboarding_profilepic_last_presented_date
	) {
		steps.push(onboardingSteps.PROFILE_PIC)
	}
	if (
		orgFlag(USER_PRONOUNS) &&
		user.permissions?.change_own_pronouns &&
		!user.pronouns &&
		!user.client_meta.onboarding_pronouns_last_presented_date
	) {
		steps.push(onboardingSteps.PRONOUNS)
	}
	if (
		orgFlag(USER_TITLE) &&
		user.permissions?.change_own_title &&
		!user.title &&
		!user.client_meta.onboarding_title_last_presented_date
	) {
		steps.push(onboardingSteps.TITLE)
	}
	return steps
}
